import { ColDef } from 'ag-grid-community';
import {
  RESOURCE_FIELD,
  EMAIL_ID_FIELD,
  RM_FIELD,
  LEADER_FIELD,
  COMPANY_FIELD,
  POI_TYPE_FIELD,
  LAPTOP_FIELD,
  LAPTOP_ISSUE_DATE_FIELD,
  ACCESSORIES_FIELD,
  DOJ_FIELD,
  REQUEST_STATUS_FIELD,
  LAST_HIRE_DATE_FIELD,
  ACCESSORIES_TYPE_FIELD,
  CREATED_BY_FIELD,
  EMPLOYER_FIELD,
  LAPTOP_SERIAL_FIELD,
  CHARGER_SERIAL_FIELD,
  REQUESTED_BY_OFFBOARDING_FIELD,
  DATE_OF_RETURN_FIELD,
  DATE_OF_OFFBOARDING_FIELD,
  EMPLOYEE_STATUS_FIELD,
  LAST_WORKING_DAY_FIELD,
  STATUS_OFFBOARDING_FIELD,
  VENDOR_NAME,
  Total_CWR,
  Onboarded_CWR,
  Offboarded_CWR,
  PRODUCT_NAME,
  ISSUED_QUANTITY,
  LOCATION,
  DATE_OF_ISSUE,
  CATEGORY_FIELD,
  PRODUCT_NAME_PROCURED,
  OPENING_QUANTITY,
  DATE_OF_PURCHASE,
  QUANTITY_PURCHASED,
  AVAILABLE_BALANCE,
  RESOURCE_OFFBOARDING_FIELD,
  OS_TYPE,
  DAMAGE_COST,
  RESOURCE_PLAIN_FIELD,
  RESOURCE_ASSETALLOCATED_FIELD,
  RESOURCE_DAMAGE_FIELD,
  RETURN_STATUS_OFFBOARDING_FIELD,
  OFFBOARDING_COMMENTS_FIELD,
  EMPLOYEE_PLAIN_FIELD,
  DATE_OF_ENTRY,
} from '../../shared/components/table/table-field-definitions';
import { ActionConfig } from '../../shared/components/table/table-action-configs';
import { AddCommentsRenderer } from './add-comments-renderer.component';
import { StatusRenderer } from './status-renderer.component';
import { ResourceNameCellRendererComponent } from '../../shared/components/table/resource-name-cell-renderer/resource-name-cell-renderer.component';
import { CopyCellRendererComponent } from '../../shared/components/table/copy-cell-renderer/copy-cell-renderer.component';
import { DateOfReturnCellComponent } from '../../shared/components/table/custom-cell-renderers/date-of-return-cell.component';
import { STATUSCONSTANTS } from '@app/shared/constants/constants';

// ============================================================================
// COLUMN DEFINITIONS (ColDef)
// ============================================================================

export const MY_REQUEST_COLUMNS: ColDef[] = [
  RESOURCE_FIELD,
  EMAIL_ID_FIELD,
  RM_FIELD,
  EMPLOYER_FIELD,
  LEADER_FIELD,
  LOCATION,
  LAPTOP_FIELD,
  ACCESSORIES_TYPE_FIELD,
  CREATED_BY_FIELD,
  LAST_HIRE_DATE_FIELD,
  REQUEST_STATUS_FIELD,
];

export const UPCOMING_OFFBOARDING_COLUMNS: ColDef[] = [
  {
    ...EMPLOYEE_PLAIN_FIELD,
    width: 190,
    minWidth: 190,
    maxWidth: 190,
  },
  {
    ...RM_FIELD,
    width: 190,
    minWidth: 190,
    maxWidth: 190,
  },
  LEADER_FIELD,
  {
    ...COMPANY_FIELD,
    width: 120,
    minWidth: 120,
    maxWidth: 120,
  },
  {
    ...DATE_OF_OFFBOARDING_FIELD,
  },
];

export const UPCOMING_ONBOARDING_CARD_COLUMNS: ColDef[] = [
  {
    ...EMPLOYEE_PLAIN_FIELD,
    width: 190,
    minWidth: 190,
    maxWidth: 190,
  },
  {
    ...RM_FIELD,
    width: 190,
    minWidth: 190,
    maxWidth: 190,
  },
  LEADER_FIELD,
  {
    ...COMPANY_FIELD,
    width: 120,
    minWidth: 120,
    maxWidth: 120,
  },
  { ...DOJ_FIELD, width: 100, minWidth: 100, maxWidth: 100 },
];

export const ONBOARDING_COLUMNS: ColDef[] = [
  RESOURCE_FIELD,
  EMAIL_ID_FIELD,
  RM_FIELD,
  LEADER_FIELD,
  COMPANY_FIELD,
  LOCATION,
  LAPTOP_FIELD,
  ACCESSORIES_TYPE_FIELD,
  CREATED_BY_FIELD,
  DOJ_FIELD,
  REQUEST_STATUS_FIELD,
];

export const OFFBOARDING_COLUMNS: ColDef[] = [
  RESOURCE_OFFBOARDING_FIELD,
  EMAIL_ID_FIELD,
  RM_FIELD,
  LEADER_FIELD,
  COMPANY_FIELD,
  LOCATION,
  LAPTOP_FIELD,
  LAPTOP_SERIAL_FIELD,
  CHARGER_SERIAL_FIELD,
  ACCESSORIES_TYPE_FIELD,
  REQUESTED_BY_OFFBOARDING_FIELD,
  DATE_OF_RETURN_FIELD,
  DATE_OF_OFFBOARDING_FIELD,
  RETURN_STATUS_OFFBOARDING_FIELD,
  OFFBOARDING_COMMENTS_FIELD,
  EMPLOYEE_STATUS_FIELD,
];

export const DAMAGE_ANALYTICS_COLUMNS: ColDef[] = [
  RESOURCE_DAMAGE_FIELD,
  EMAIL_ID_FIELD,
  OS_TYPE,
  DATE_OF_ENTRY,
  LAPTOP_SERIAL_FIELD,
  DAMAGE_COST,
  COMPANY_FIELD,
  {
    field: 'damageCostStatus',
    headerName: 'Recovery Status',
    resizable: true,
    minWidth: 200,
    sortable: true,
    filter: false,
    cellRenderer: 'statusRenderer',
    cellRendererParams: {
      showDropdown: false,
      category: 'Damage',
      isDamageAnalytics: true,
    },
  },
  {
    field: 'comments',
    headerName: 'Comments',
    sortable: true,
    resizable: true,
    minWidth: 250,
    filter: false,
    cellRenderer: 'addCommentsRenderer',
    cellRendererParams: {
      isDamageAnalytics: true,
    },
  },
];

export const VENDOR_STATS_COLUMNS: ColDef[] = [
  VENDOR_NAME,
  Total_CWR,
  Onboarded_CWR,
  Offboarded_CWR,
];


export const INVENTORY: ColDef[] = [
  { field: 'category', headerName: 'Category', minWidth: 200, sortable: true, filter: false, pinned: 'left' },
  { ...PRODUCT_NAME, pinned: null },
  { field: 'issuedTo', headerName: 'Issued To', minWidth: 180, sortable: true, filter: false },
  { field: 'quantity', headerName: 'Quantity', minWidth: 150, sortable: true, filter: false },
  LOCATION,
  DATE_OF_ISSUE,
  { field: 'purpose', headerName: 'Purpose', minWidth: 200, sortable: true, filter: false, flex: 1 },
];

export const INVENTORY_ORDER: ColDef[] = [
  CATEGORY_FIELD,
  PRODUCT_NAME_PROCURED,
  LOCATION,
  OPENING_QUANTITY,
  DATE_OF_PURCHASE,
  QUANTITY_PURCHASED,
  ISSUED_QUANTITY,
  AVAILABLE_BALANCE,
];

// Columns for Asset Allocated table (Resource, Email ID, POI Type, RM, Leader, Company, Location, Laptop, Laptop S/N, Laptop Issue Date, Charger S/N, Accessories, DOJ)
// Optimized for auto-sizing with flex instead of fixed widths
export const ASSET_ALLOCATED_COLUMNS: ColDef[] = [
  RESOURCE_ASSETALLOCATED_FIELD,
  EMAIL_ID_FIELD,
  LOCATION,
  DATE_OF_ENTRY,
  LAPTOP_FIELD,
  LAPTOP_SERIAL_FIELD, // Fixed width with copy button
  LAPTOP_ISSUE_DATE_FIELD,
  CHARGER_SERIAL_FIELD, // Fixed width with copy button
  ACCESSORIES_TYPE_FIELD,
  POI_TYPE_FIELD,
  RM_FIELD,
  LEADER_FIELD,
  COMPANY_FIELD,
  DOJ_FIELD,
];
// ============================================================================
// ACTION CONFIGURATIONS (ActionConfig)
// ============================================================================

// Centralized ActionConfig objects
export const EDIT_ACTION: ActionConfig = {
  action: 'edit',
  label: 'Edit',
  icon: 'edit',
  tooltip: 'Edit',
  cssClass: 'btn-edit',
  iconposition: 'Left',
  disabled: (rowData: any) => {
    return (
      rowData?.status?.toLowerCase() === 'delivered' ||
      rowData?.status?.toLowerCase() === 'cancelled'
    );
  },
};

export const VIEW_ACTION: ActionConfig = {
  action: 'view',
  label: 'View',
  icon: 'visibility',
  tooltip: 'View details',
  cssClass: 'btn-view',
};

export const APPROVE_ACTION: ActionConfig = {
  action: 'approve',
  label: 'Approve',
  icon: 'check_circle',
  tooltip: 'Approve',
  visible: (row: any) => row.status === STATUSCONSTANTS.PENDING,
  cssClass: 'btn-approve',
};

export const REJECT_ACTION: ActionConfig = {
  action: 'reject',
  label: 'Reject',
  icon: 'cancel',
  tooltip: 'Reject',
  visible: (row: any) =>
    row.status === STATUSCONSTANTS.PENDING ||
    row.status === STATUSCONSTANTS.INITIATED,
  cssClass: 'btn-reject',
};

export const DELETE_ACTION: ActionConfig = {
  action: 'delete',
  label: 'Delete',
  icon: 'delete',
  tooltip: 'Delete',
  visible: (row: any) =>
    row.status === STATUSCONSTANTS.INITIATED ||
    row.status === STATUSCONSTANTS.CANCELLED,
  cssClass: 'btn-delete',
};

export const ADD_OR_REPLACE_ASSET_ACTION: ActionConfig = {
  action: 'addOrReplaceAsset',
  label: 'Add or Replace Asset/Accessories',
  icon: 'add',
  tooltip: 'Add or replace asset or accessories',
  cssClass: 'btn-edit',
};

// Specialized edit actions with custom visibility
export const EDIT_ONBOARDING_ACTION: ActionConfig = {
  ...EDIT_ACTION,
  tooltip: 'Edit onboarding',
  visible: (row: any) => row.status !== STATUSCONSTANTS.COMPLETED,
};

export const EDIT_OFFBOARDING_ACTION: ActionConfig = {
  ...EDIT_ACTION,
  tooltip: 'Edit offboarding',
  visible: (row: any) =>
    row.status !== STATUSCONSTANTS.CANCELLED &&
    row.status !== STATUSCONSTANTS.COMPLETED,
};

export const EDIT_VENDOR_ACTION: ActionConfig = {
  ...EDIT_ACTION,
  tooltip: 'Edit vendor',
  visible: (row: any) =>
    row.status !== STATUSCONSTANTS.CANCELLED &&
    row.status !== STATUSCONSTANTS.COMPLETED,
};

export const EDIT_INVENTORY_ACTION: ActionConfig = {
  ...EDIT_ACTION,
  tooltip: 'Edit inventory',
  visible: (row: any) =>
    row.status !== STATUSCONSTANTS.CANCELLED &&
    row.status !== STATUSCONSTANTS.COMPLETED,
};

export const EDIT_DAMAGE_ANALYTICS_ACTION: ActionConfig = {
  ...EDIT_ACTION,
  tooltip: 'Edit damage record',
  columnWidth: 200,
  visible: (row: any) =>
    row.damageCostStatus == 'Pending' || row.damageCostStatus == null,
};

export const EDIT_MY_REQUEST_ACTION: ActionConfig = {
  ...EDIT_ACTION,
  tooltip: 'Edit my request',
  disabled(rowData) {
    return (
      rowData.status?.toLowerCase() === 'delivered' ||
      rowData.status?.toLowerCase() === 'cancelled'
    );
  },
};

export const CANCEL_DAMAGE_ANALYTICS_ACTION: ActionConfig = {
  action: 'delete',
  label: 'Cancel',
  icon: 'cancel',
  tooltip: 'Cancel',
  cssClass: 'btn-delete btn-edit',
  columnWidth: 250,
};

// ActionConfig arrays
export const MY_REQUEST_ACTIONS: ActionConfig[] = [EDIT_MY_REQUEST_ACTION];
export const ONBOARDING_ACTIONS: ActionConfig[] = [EDIT_ONBOARDING_ACTION];
export const OFFBOARDING_ACTIONS: ActionConfig[] = [
  VIEW_ACTION,
  EDIT_OFFBOARDING_ACTION,
  APPROVE_ACTION,
  REJECT_ACTION,
  DELETE_ACTION,
];
export const ASSET_ALLOCATED_SINGLE_ACTIONS: ActionConfig[] = [
  ADD_OR_REPLACE_ASSET_ACTION,
];
export const INVENTORY_ACTIONS: ActionConfig[] = [EDIT_INVENTORY_ACTION];
export const VENDOR_STATS_ACTIONS: ActionConfig[] = [
  VIEW_ACTION,
  EDIT_VENDOR_ACTION,
  APPROVE_ACTION,
  REJECT_ACTION,
  DELETE_ACTION,
];
export const DAMAGE_ANALYTICS_ACTIONS: ActionConfig[] = [
  EDIT_DAMAGE_ANALYTICS_ACTION,
  CANCEL_DAMAGE_ANALYTICS_ACTION,
];

// ============================================================================
// TABLE CONFIGURATIONS
// ============================================================================

export const UPCOMING_TABLE_CONFIG = {
  columns: UPCOMING_ONBOARDING_CARD_COLUMNS,
  actions: [],
  enableRowSelection: false,
  rowSelectionMode: 'multiple' as const,
  enableActions: false,
  enablePagination: false,
  paginationPageSize: 5,
  enableSorting: true,
  enableFiltering: true,
  enableColumnResize: true,
};

export const UPCOMING_OFFBOARDING_TABLE_CONFIG = {
  columns: UPCOMING_OFFBOARDING_COLUMNS,
  actions: [],
  enableRowSelection: false,
  rowSelectionMode: 'multiple' as const,
  enableActions: false,
  enablePagination: false,
  paginationPageSize: 5,
  enableSorting: true,
  enableFiltering: true,
  enableColumnResize: true,
};
export const MY_REQUEST_TABLE_CONFIG = {
  columns: MY_REQUEST_COLUMNS,
  actions: MY_REQUEST_ACTIONS,
  enableRowSelection: true,
  rowSelectionMode: 'multiple' as const,
  enableActions: true,
  enablePagination: true,
  paginationPageSize: 10,
  enableSorting: true,
  enableFiltering: true,
  enableColumnResize: true,
};

export const ONBOARDING_TABLE_CONFIG = {
  columns: ONBOARDING_COLUMNS,
  actions: ONBOARDING_ACTIONS,
  enableRowSelection: true,
  rowSelectionMode: 'multiple' as const,
  enableActions: true,
  enablePagination: true,
  paginationPageSize: 10,
  enableSorting: true,
  enableFiltering: true,
  enableColumnResize: true,
};

export const OFFBOARDING_TABLE_CONFIG = {
  columns: OFFBOARDING_COLUMNS,
  actions: OFFBOARDING_ACTIONS,
  enableRowSelection: true,
  rowSelectionMode: 'multiple' as const,
  enableActions: false,
  enablePagination: true,
  paginationPageSize: 10,
  enableSorting: true,
  enableFiltering: true,
  enableColumnResize: true,
};

export const ASSET_ALLOCATED_TABLE_CONFIG = {
  columns: ASSET_ALLOCATED_COLUMNS,
  actions: ASSET_ALLOCATED_SINGLE_ACTIONS,
  enableRowSelection: true,
  rowSelectionMode: 'multiple' as const,
  enableActions: false,
  enablePagination: true,
  paginationPageSize: 10,
  enableSorting: true,
  enableFiltering: true,
  enableColumnResize: true,
  enableAutoSizing: true, // Enable auto-sizing
};

export const INVENTORY_TABLE_CONFIG = {
  columns: INVENTORY,
  actions: INVENTORY_ACTIONS,
  enableRowSelection: true,
  rowSelectionMode: 'multiple' as const,
  enableActions: true,
  enablePagination: true,
  paginationPageSize: 10,
  enableSorting: true,
  enableFiltering: true,
  enableColumnResize: true,
};

export const INVENTORY_ORDER_TABLE_CONFIG = {
  columns: INVENTORY_ORDER,
  enableRowSelection: true,
  rowSelectionMode: 'multiple' as const,
  enableActions: false,
  enablePagination: true,
  paginationPageSize: 10,
  enableSorting: true,
  enableFiltering: true,
  enableColumnResize: true,
};

export const VENDOR_STATS_TABLE_CONFIG = {
  columns: VENDOR_STATS_COLUMNS,
  actions: VENDOR_STATS_ACTIONS,
  enableRowSelection: true,
  rowSelectionMode: 'multiple' as const,
  enableActions: false,
  enablePagination: true,
  paginationPageSize: 10,
  enableSorting: true,
  enableFiltering: true,
  enableColumnResize: true,
};

export const DAMAGE_ANALYTICS_TABLE_CONFIG = {
  columns: DAMAGE_ANALYTICS_COLUMNS,
  actions: DAMAGE_ANALYTICS_ACTIONS,
  enableRowSelection: true,
  rowSelectionMode: 'multiple' as const,
  enableActions: true,
  enablePagination: true,
  paginationPageSize: 10,
  enableSorting: true,
  enableFiltering: true,
  enableColumnResize: true,
  rowClassRules: {
    'cancelled-row': (params: any) =>
      params.data?.damageCostStatus === 'cancelled',
  },
};

// ============================================================================
// FRAMEWORK COMPONENTS
// ============================================================================

export const FRAMEWORK_COMPONENTS = {
  addCommentsRenderer: AddCommentsRenderer,
  statusRenderer: StatusRenderer,
  ResourceNameCellRenderer: ResourceNameCellRendererComponent,
  CopyCellRenderer: CopyCellRendererComponent,
  DateOfReturnCell: DateOfReturnCellComponent,
};